import moment from 'moment'
class StringUtil {
    static getParamData(param){
        const url = window.location.href
        const newUrl = new URL(url)
        const paramData = newUrl.searchParams.get(param)
        return paramData
    }

    /**
     * KIOSK の引き継ぎコード（DMS-1268-E）を URL のフラグメントから取り出す。
     *
     * クエリではなく**フラグメント**に載せるのは、フラグメントが仕様上サーバーへ
     * 送られないため。Referer にもアクセスログにも残らない。
     * api-nest が発行するコードは 43 文字の base64url なので、形の違う値は拾わない。
     */
    static getHandoffCode(){
        const hash = window.location.hash || ''
        const matched = /(?:^#|&)code=([A-Za-z0-9_-]{43})(?:&|$)/.exec(hash)
        return matched ? matched[1] : null
    }

    /**
     * 同行者招待のトークン（DMS-1268-F）を URL のフラグメントから取り出す。
     * 取り出し方は引き継ぎコードと同じで、パラメータ名だけが違う
     * （引き換え先の API が別なので、名前で見分ける）。
     */
    static getInviteToken(){
        const hash = window.location.hash || ''
        const matched = /(?:^#|&)invite=([A-Za-z0-9_-]{43})(?:&|$)/.exec(hash)
        return matched ? matched[1] : null
    }

    /**
     * 引き換えの済んだコード・トークンを URL から消す。
     * 残したままだと、ゲストが URL を共有したときに（使用済みとはいえ）外へ出る。
     */
    static clearUrlFragment(){
        if(!window.history || !window.history.replaceState){
            return
        }
        const url = new URL(window.location.href)
        window.history.replaceState(null, '', url.pathname + url.search)
    }

    static dateToString(val, format = 'YYYY/MM/DD'){
        if(val.includes('T')){
            return val.substr(0, 10).replace(/-/g, '/')
        }else{
            return moment(val).format(format);
        }
    }
}

export default StringUtil